import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';
import { getLanguagesSelector } from '@store/language/language.selectors';
import { fetchLanguages } from '@store/language/language.actions';
import { LanguageState } from '@models/index';

import { HelperService } from '@services/helper/helper.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  backendUrl = environment.backendUrl;

  constructor(
    private store: Store<{language: LanguageState}>,
    private http: HttpClient
  ) {
  }

  getLanguagesSelector(): Observable<LanguageState> {
    return this.store.select(getLanguagesSelector);
  }

  fetchLanguages(filterOptions) {
    this.store.dispatch(fetchLanguages({filterOptions}));
  }

  getLanguages(filterOptions) {
    const queryString = HelperService.generateQueryParams(filterOptions);

    return this.http.get(`${this.backendUrl}/statics/languages?${queryString}`);
  }
}
